import { render, staticRenderFns } from "./ResourceCardVideo.vue?vue&type=template&id=728ef522&scoped=true&"
import script from "./ResourceCardVideo.vue?vue&type=script&lang=js&"
export * from "./ResourceCardVideo.vue?vue&type=script&lang=js&"
import style0 from "./ResourceCardVideo.vue?vue&type=style&index=0&id=728ef522&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728ef522",
  null
  
)

export default component.exports